if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}

// The compact mobile footer has two popovers, but only one should remain open.
const initMobileFooterPopovers = () => {
  const popovers = [...document.querySelectorAll('.ut-mobile-footer__popover')];
  popovers.forEach((popover) => {
    if (popover.dataset.utPopoverBound === 'true') return;
    popover.dataset.utPopoverBound = 'true';
    popover.addEventListener('toggle', () => {
      if (!popover.open) return;
      popovers.forEach((other) => {
        if (other !== popover) other.open = false;
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileFooterPopovers, { once: true });
} else {
  initMobileFooterPopovers();
}

document.addEventListener('shopify:section:load', initMobileFooterPopovers);
